import React, { useState, useEffect, useMemo } from 'react'
import { Image, StyleProp, ViewStyle, StyleSheet } from 'react-native'
import { DNABox, util } from '@alucio/lux-ui'
import { useUserTenant } from 'src/state/redux/selector/user';
import { getImageFromCloudfront } from 'src/utils/loadCloudfrontAsset/loadCloudfrontAsset';

const S = StyleSheet.create({
  container: {
    height: '100%',
    width: '100%',
  },
  image: {
    height: '100%',
    width: '100%',
  },
})

type DNATenantLogoProps = {
  size?: 'small' | 'medium' | 'large'
  // will override the logo from the tenant
  imageUrl?: string
  style?: StyleProp<ViewStyle>
}

const sizeMap: { [K in Exclude<DNATenantLogoProps['size'], undefined>]: number } = {
  small: 100,
  medium: 174,
  large: 300,
}

const useLogo = (logoImageDataIn?: string) => {
  const tenant = useUserTenant();
  const [logoImageData, setLogoImageData] = useState('');
  const alucioLogo = require('../../../../assets/images/alucio_logo.png');

  useEffect(() => {
    if (logoImageDataIn) {
      setLogoImageData(logoImageDataIn);
    } else {
      if (tenant) {
        // The logo is always located in the tenant's content folder under /logo.png
        const logoUrl = `${tenant.id}/logo.png`;
        getImageFromCloudfront(logoUrl).then(image => {
          if (image) {
            setLogoImageData(image)
          } else {
            setLogoImageData(alucioLogo);
          }
        }, () => {
          setLogoImageData(alucioLogo);
        });
      } else {
        // IF THERE IS NO TENANT, THE USER IS AN ADMIN
        setLogoImageData(alucioLogo);
      }
    }
  }, [logoImageDataIn, tenant?.id])

  return { logoImageData, readOnly: !!logoImageDataIn }
}

const DNATenantLogo: React.FC<DNATenantLogoProps> = (props) => {
  const { size = 'small', style } = props
  const { logoImageData } = useLogo(props.imageUrl)

  const boxStyle = useMemo(
    () => util.mergeStyles(
      undefined,
      { width: sizeMap[size] },
      style,
    ),
    [style, size]
  )

  return (
    <DNABox
      testID="tenantLogo"
      style={boxStyle}
    >
      <div style={S.container}>
        <Image
          style={S.image}
          resizeMode="contain"
          source={{ uri: logoImageData }}
        />
      </div>
    </DNABox>
  )
}

export default DNATenantLogo
